
export default class {
    static getScenarioSchema() {
        return {
                fields: [                 
                
                    {
                        name: 'clients',
                        type: 'Group',
                        label: 'Applicants',
                        columns: true,
                        width: '240px',
                        summary: "[$first_name + ' ' + $last_name]",
                        fields: [
                            {
                                type: 'Text',
                                name: 'first_name',
                                label: 'First Name',
                                default: 'Client [n]'
                            },
                            {
                                type: 'Text',
                                name: 'last_name',
                                label: 'Last Name',
                            },
                            {
                                type: 'Text',
                                name: 'email',
                                label: 'Email',
                            },
                        ]
                    },
                    {
                        name: 'children',
                        type: 'Group',
                        label: 'Children',
                        columns: true,
                        summary: '[$age]',
                        fields: [
                            {
                                type: 'Text',
                                name: 'age',
                                label: 'Age',
                            },
                        ]
                    },

                    {   // Properties and Mortgages
                        name: 'existing_properties',
                        horizontal: true,
                        type: 'Group',
                        label: 'Existing Properties [$brackets($currency($existing_properties_total_property_value))]',
                        //visible: "[$owns_existing_property == 'Yes']",
                        summary: "[$address + ' ' + $currency($property_value)]",

                        fields: [
                            {
                                type: 'Text',
                                name: 'address',
                                label: 'Address',
                                default: 'Property [n]',
                                compact: true,
                                width: '300px',
                            },
                            {
                                name: 'property_value',
                                type: 'Currency',
                                label: 'Value',
                                width: '130px',
                                compact: true,
                            },
                            {
                                name: 'investment_property',
                                type: 'Switch',
                                label: 'Investment',
                                width: '130px',
                                compact: true,
                            },     
                            {
                                name: 'rental_income',
                                type: 'Payment',
                                label: 'Ongoing Rent',
                                width: '130px',
                                defaultFrequency: 'pw',
                                visible:  "[$investment_property && $property_intention != 'selling']"
                            },                                 
                            {
                                name: 'mortgage_heading',
                                type: 'Section',
                                label: 'Mortgage',
                                horizontal: true,
                                width: '100%',
                                fields: [
                                    {
                                        name: 'lender',
                                        type: 'Text',
                                        label: 'Lender',
                                        width: '200px'
                                    },                                                  
                                    {
                                        name: 'owing',
                                        type: 'Currency',
                                        label: 'Owing',
                                        width: '130px'
                                    },                                                  
                                    {
                                        name: 'mortgage_payment',
                                        type: 'Payment',
                                        label: 'Repayment',
                                        width: '130px',
                                    },  
                                ],
                                visible: "[$property_intention != 'unencumbered']",

                            },  
                            
                                                
                            {
                                name: 'property_intention',
                                type: 'DropdownLabel',
                                label: 'Intention',
                                // width: '130px',
                                items: [
                                    {value: 'refinance', text: 'Keeping, Refinance'},
                                    {value: 'keep', text: 'Keeping, No Change'},
                                    {value: 'selling', text: 'Selling'},
                                    {value: 'unencumbered', text: 'No Mortgage'},
                                ]
                            },
                          
                  
                        ]
                    },


                    // {
                    //     name: 'owns_existing_property',
                    //     type: 'YesNo',
                    //     label: 'Property Owner',
                    //     question: 'Do you own existing property?',
                    // },
                    // {
                    //     name: 'purchasing_property',
                    //     type: 'YesNo',
                    //     label: 'Buyer',
                    //     question: 'Are you buying property?',
                    // },

                    {
                        name: 'loan_purpose_section',
                        type: 'Section',
                        label: "Loan Purpose [$brackets($currency($loan_purpose_section_total_currency))]",
                        summary: '[$true_labels]',
                        fields: [
                            {
                                name: 'purchase_property',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Purchase Property',
                            },                                                      
                            {
                                name: 'refinance_property',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Refinance Property',
                            },                                                      
                            {
                                name: 'debt_consolidation',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Debt Consolidation',
                            },                                                      
                            {
                                name: 'cash_out',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Other Cash Out',
                            },                                                      
                            {
                                name: 'cash_out_reason',
                                type: 'Text',
                                label: 'Reason for Cash',
                                visible: '[$cash_out_exists]'
                            },                                                      
                                                                                                                 
                                                       
                        ]
                    },


                    {
                        name: 'purchase_details_section',
                        type: 'Section',
                        label: 'About your purchase [$brackets($currency($purchase_details_section_total_currency))]',
                        visible: "[$purchase_property_exists]",
                        summary: '[$true_labels]',

                        // columns: [ 
                        //     {
                                fields: [
                                    {
                                        name: 'owner_occupied_property',
                                        type: 'SwitchHeading',
                                        inputType: 'Currency',
                                        label: 'Owner Occupied',
                                    }, 
                                    {
                                        name: 'investment_property',
                                        type: 'SwitchHeading',
                                        inputType: 'Currency',
                                        label: 'Investment Property',
                                    }, 
                                    {
                                        name: 'land_property',
                                        type: 'SwitchHeading',
                                        inputType: 'Currency',
                                        label: 'Buying Land',
                                    }, 
                                    {
                                        name: 'construction',
                                        type: 'SwitchHeading',
                                        inputType: 'Currency',
                                        label: 'Construction',
                                    }, 
                                    {
                                        name: 'found_property',
                                        type: 'Radio',
                                        label: 'Have you found a property',
                                        items: [{text: 'Yes'},{text: 'No - Preapproval Only', value: 'No'}]
                                    }, 
                            //     ]
                            // },
                        ]

                    },





                    {
                        name: 'deposit_section',
                        type: 'Section',
                        label: 'Where is your deposit coming from? [$brackets($currency($deposit_section_total_currency))]',
                        visible: "[$purchase_property_exists]",
                        summary: '[$true_labels]',

                        fields: [

                            {
                                name: 'genuine_savings',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Genuine Savings',
                                visible: "[$existing_properties_count == 0]",
                            }, 
                            {
                                name: 'government_grant',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Grant',
                                visible: "[$existing_properties_count == 0]",
                            }, 

                            {
                                name: 'property_equity',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Equity in existing property',
                                visible: "[$existing_properties_count > 0]",
                            }, 

                            {
                                name: 'gifted_funds',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Gifted Funds',
                            }, 

                            {
                                name: 'other_funds',
                                type: 'SwitchHeading',
                                inputType: 'Currency',
                                label: 'Other Funds (not saved)',
                            }, 
                            {
                                type: 'Checkbox',
                                label: 'Guarantor',
                                name: 'guarantor_exists',
                                visible: "[$existing_properties_count == 0]",
                            },   
                          
                        ]
                    },


                    {
                        name: 'clients',
                        type: 'Group',
                        label: 'Incomes',
                        columns: true,
                        width: '240px',
                        hideButtons: true,
                        visible: "[$clients.length > 0]",
                        fields: [
                            {
                                type: 'SectionHeading',
                                label: "[$first_name || 'Income']",
                            },
                            {
                                type: 'Currency',
                                name: 'work_income',
                                label: 'Job Income',
                            },
                            {
                                type: 'Radio',
                                name: 'employment_type',
                                label: 'EmploymentType',
                                items: [{text: 'Permanent Full Time'},{text: 'Permanent Part Time'},{text: 'Casual'}]
                            },
                            {
                                visible: "[$employment_type.startsWith('Permanent')]",
                                name: 'overtime_exists',
                                label: 'Receive Overtime/Allowances',
                                type: 'Checkbox',
                            },
                            {
                                visible: "[$employment_type.startsWith('Permanent')]",
                                name: 'bonuses_exists',
                                label: 'Receive Bonuses',
                                type: 'Checkbox',
                            },
                            {
                                visible: "[$employment_type.startsWith('Permanent')]",
                                name: 'salary_sacrifice',
                                label: 'Salary Sacrifice',
                                type: 'Checkbox',
                            },
                            {
                                visible: "[$employment_type.startsWith('Permanent')]",
                                name: 'company_car',
                                label: 'Company Car',
                                type: 'Checkbox',
                            },
                            {
                                name: 'self_employed',
                                label: 'Self Employed Income',
                                type: 'Checkbox',
                            },                            
                            {
                                name: 'net_se_income',
                                label: 'Net after expenses',
                                type: 'Currency',
                                visible: "[$self_employed]",
                            },                            
                            {
                                visible: "[$self_employed]",
                                name: 'sole_trader',
                                label: 'Sole Trader',
                                type: 'Checkbox',
                            },
                            {
                                visible: "[$self_employed]",

                                name: 'se_company',
                                label: 'Company',
                                type: 'Checkbox',
                            },
                            {
                                visible: "[$self_employed]",
                                name: 'se_trust',
                                label: 'Trust',
                                type: 'Checkbox',
                            },
                   
                        ]
                    },


                    {
                        name: 'extra_income_section',
                        type: 'Section',
                        label: 'Do you have any additional income?',
                        summary: '[$true_labels]',

                        fields: [
                            {
                                name: 'family_payments',
                                type: 'SwitchHeading',
                                inputType: 'Payment',
                                defaultFrequency: 'pf',
                                label: 'Family Payments',
                                visible: "[$children]",
                            },                                                      
                            {
                                name: 'child_support',
                                type: 'SwitchHeading',
                                inputType: 'Payment',
                                defaultFrequency: 'pm',
                                label: 'Child Support',
                                visible: "[$children]",
                            },                                                      
                            {
                                name: 'government_payments',
                                type: 'SwitchHeading',
                                inputType: 'Payment',
                                defaultFrequency: 'pf',
                                label: 'Government Payments',
                                title: 'Government'
                            },                                                                                                         
                            {
                                name: 'rental_income_estimate',
                                type: 'SwitchHeading',
                                inputType: 'Payment',
                                defaultFrequency: 'pw',
                                label: 'Rental Income',
                                title: 'Rent'
                            },                                                                                                         
                            {
                                name: 'investment_income',
                                type: 'SwitchHeading',
                                inputType: 'Payment',
                                defaultFrequency: 'pa',
                                label: 'Investment Income',
                                title: 'Investments'
                            },                                                                                                         
                                                                                                                      
                            {
                                visible: "[$investment_income_exists]",
                                name: 'investment_income_details',
                                type: 'Text',
                                label: 'Investment Income Details',
                            },                                                      
                        ]
                    },

                    


                    // Personal Loans...
                    
                    {
                        horizontal: true,
                        type: 'group',
                        name: 'personal_loans',
                        label: 'Personal/Car Loans [$brackets($currency($personal_loans_total_payment), " pm")]',
                        summary: '[$description]',
                        fields: [
                            {
                                type: 'Text',
                                name: 'description',
                                label: 'Description',
                                default: 'Loan [n]'
                            },
                            {
                                name: 'payment',
                                type: 'Payment',
                                label: 'Payment',
                                defaultFrequency: 'pm',
                                width: '130px',
                                total: ['total'],
                            },
                            {
                                name: 'balance',
                                type: 'Currency',
                                label: 'Balance Owing',
                                width: '130px',
                            },
                            {
                                name: 'personal_loan_intention',
                                type: 'DropdownLabel',
                                label: 'Intention',
                                items: [
                                    {value: 'keep', text: 'Keeping, No Change'},
                                    {value: 'refinance', text: 'Close with Loan Funds'},
                                    {value: 'close', text: 'Close with Own Funds'},
                                ],
                                default: 'keep',
                            },                            
                        ]
                    },

                    // Credit Cards
                    {
                        horizontal: true,
                        type: 'group',
                        name: 'cards',
                        label: 'Credit/Store Cards [$brackets($currency($cards_total_card_limit), " lmt")]',
                        summary: "[$description + ' ' + $currency($card_limit)]",
                        fields: [
                            {
                                default: 'Credit Card [n]',
                                name: 'description',
                                type: 'Text',
                                label: 'Description',
                            },
                            {
                                name: 'card_limit',
                                type: 'Currency',
                                label: 'Card Limit',
                                width: '130px',
                            },

                            {
                                name: 'card_intention',
                                type: 'DropdownLabel',
                                label: 'Intention',
                                items: [
                                    {value: 'keep', text: 'Keeping, No Change'},
                                    {value: 'refinance', text: 'Close with Loan Funds'},
                                    {value: 'close', text: 'Close with Own Funds'},
                                ],
                                default: 'keep'
                            },


                        ]
                    },

                    // Special Circumstances...

                    {
                        name: 'special_circumstances',
                        type: 'Section',
                        label: 'More Specifics',
                        summary: '[$true_labels]',
                        fields: [
                            {
                                name: 'mature',
                                type: 'Checkbox',
                                title: 'Over 45',
                                label: 'Over 45 years old',
                            }, 
                            {
                                name: 'bad_credit',
                                type: 'Checkbox',
                                title: 'Bad Credit',
                                label: 'Credit defaults, late payments or similar',
                            }, 
                            {
                                name: 'previous_companies',
                                type: 'Checkbox',
                                title: 'Prev Companies',
                                label: 'Previous companies or trusts no longer used',
                            }, 
                            {
                                name: 'relationship_section',
                                type: 'SectionHeading',
                                label: 'Relationships',
                            }, 
                            {
                                name: 'separating',
                                type: 'Checkbox',
                                title: 'Separating',
                                label: 'Separating from partner',
                            },                             
                            {
                                name: 'paying_child_support',
                                type: 'Checkbox',
                                title: 'CSA',
                                label: 'Paying child support',
                            },                             
                            {
                                name: 'paying_commitments',
                                type: 'Checkbox',
                                title: 'Partner debts',
                                label: 'Partner has debts, cards, child support or commitments not listed here',
                            },                             
                        ]
                    }

                ]
        }

    }

    static getTestSchema() {
        return {
            fields: [
                    {
                        type: 'Text',
                        name: 'first_name',
                        label: 'First Name',
                    },
                    {
                        type: 'Text',
                        name: 'last_name',
                        label: 'Last Name',
                    },
                    {
                        type: 'Text',
                        name: 'email',
                        label: 'Email',
                    },
                    {
                        type: 'Checkbox',
                        name: 'friends',
                        label: 'Has Friends',
                    },
                    {
                        type: 'Currency',
                        name: 'spend',
                        label: 'Monthly Spend',
                    },
                    {
                        type: 'File',
                        name: 'contract',
                        label: 'Contract Doc',
                    },
                    {
                        type: 'Html',
                        name: 'signature',
                        label: 'Signature',
                    },
                    {
                        type: 'Payment',
                        name: 'payment',
                        label: 'Payment',
                    },
                    {
                        type: 'Number',
                        name: 'count',
                        label: 'Count of People',
                    },
                    {
                        type: 'Link',
                        name: 'address',
                        label: 'Web Address',
                    },
                    {
                        type: 'Switch',
                        name: 'fast',
                        label: 'Fast Mode',
                    },
                    {
                        type: 'SectionHeading',
                        name: '',
                        label: 'Better Stuff',
                    },
                    {
                        type: 'Radio',
                        items: [{text:'One', value: '1'},{text:'Two', value: '2'},],
                        name: 'favouriteNumber',
                        label: 'Favourite Number',
                    },
                    {
                        type: 'Group',
                        name: 'ages',
                        label: 'Ages',
                        fields: [
                            {
                                type: 'Text',
                                name: 'age',
                                label: 'Age',                                    
                            }
                        ]
                    },
            ]
        }        
    }
}


// WEBPACK FOOTER //
// ./src/dc/ChecklistSchemas.js